import type { ReactNode } from 'react'
import type { CommonProps } from '@/@types/common'
import classNames from '@/utils/classNames'

export interface ChatContainerProps extends CommonProps {
    header?: ReactNode
    input?: ReactNode
}

const ChatContainer = (props: ChatContainerProps) => {
    const { header, children, className, input } = props

    return (
        <div className={classNames('flex h-full flex-col', className)}>
            {header}
            <div className="min-h-0 flex-1">{children}</div>
            {input}
        </div>
    )
}

export default ChatContainer
